// extracted by mini-css-extract-plugin
export default {"phone":"PhoneNumber_phone__3vRE6","extension":"PhoneNumber_extension__GVCMS"};